<template>
    <v-container fluid grid-list-sm align-start>
        <v-flex xs12>
            <v-card :loading="loading">
                <v-container fluid grid-list-lg align-start>
                    <v-form v-model="valid">
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-btn
                                        class="mx-0 btn-cancel"
                                        small
                                        :disabled="loading"
                                        @click="cancel"
                                        outline
                                        fab
                                >
                                    <v-icon>arrow_back</v-icon>
                                </v-btn>

                                <h1 class="display-1">{{ eventRegistration.name }}</h1>

                                <v-btn
                                        class="btn-save mx-0"
                                        color="primary"
                                        @click="submit"
                                        :disabled="!valid || loading"
                                        :large="!$vuetify.breakpoint.xs"
                                        round
                                >{{ $t('save') }}</v-btn>

                                <dancer-selection-dialog :id="id" @ok="updateRegistration">
                                    <v-btn 
                                        class="btn-save"
                                        outline round 
                                        :large="!$vuetify.breakpoint.xs" 
                                        slot="activator" 
                                        :disabled="loading"
                                    >Nachmelden</v-btn>
                                </dancer-selection-dialog>

                                <v-tooltip bottom>
                                    <v-btn 
                                        class="btn-save"
                                        outline round 
                                        :large="!$vuetify.breakpoint.xs" 
                                        :disabled="loading"
                                        slot="activator"
                                        @click="cancelStarter"
                                    >Stornieren</v-btn>
                                    <span>Storno ohne Erstattung</span>
                                </v-tooltip>
                            </v-flex>

                            <v-flex xs12>
                                <v-text-field
                                    v-model="eventRegistration.name"
                                    label="Startername"
                                    :disabled="loading"
                                    :rules="rules.name"
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12 :sm4="eventRegistration.starter_style_id" :sm6="!eventRegistration.starter_style_id">
                                <v-autocomplete
                                    :items="filteredStarterTypes"
                                    v-model="eventRegistration.starter_type_id"
                                    :label="$t('starter_type')"
                                    item-value="id"
                                    item-text="label"
                                    :rules="rules.age_group"
                                    :disabled="loading"
                                >
                                </v-autocomplete>
                            </v-flex>

                            <v-flex xs12 :sm4="eventRegistration.starter_style_id" :sm6="!eventRegistration.starter_style_id">
                                <v-autocomplete
                                    :items="filteredAgeGroups"
                                    v-model="eventRegistration.age_group_id"
                                    :label="$t('age_group')"
                                    item-value="id"
                                    item-text="name"
                                    :rules="rules.age_group"
                                    :disabled="loading"
                                >
                                </v-autocomplete>
                            </v-flex>

                            <v-flex xs12 sm4 v-if="eventRegistration.starter_style_id">
                                <v-autocomplete
                                        :items="filteredStarterStyles"
                                        v-model="eventRegistration.starter_style_id"
                                        :label="$t('starter_style')"
                                        item-value="id"
                                        item-text="name"
                                        :disabled="loading || eventRegistration.starter_style_id === null"
                                >
                                </v-autocomplete>
                            </v-flex>

                            <v-flex xs6 sm4 md3
                                    v-for="(member, index) in eventRegistration.event_registration_members" :key="member.id"
                            >
                                <h3>{{ (index+1) + '. ' + member.first_name + ' ' + member.last_name }}</h3>

                                <v-text-field
                                        :label="$t('price')"
                                        v-model="member.price"
                                        :rules="rules.price"
                                        :disabled="loading || (eventRegistration.payment && eventRegistration.payment.invoice_id !== null)"
                                        suffix="ct"
                                        @keyup.enter="submit"
                                        required
                                ></v-text-field>

                                <v-btn 
                                    block outline small 
                                    color="red"
                                    :disabled="loading || eventRegistration.event_registration_members.length <= 1"
                                    @click="deleteMember(member)"
                                    >{{ $t('delete') }}</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-container>
            </v-card>
        </v-flex>
    </v-container>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';
    import DancerSelectionDialog from '../dialogs/DancerSelectionDialog';

    export default {
        components: {
            DancerSelectionDialog
        },
        props: {
            id: {
                type: Number,
                default: null
            }
        },
        data () {
            return {
                $validates: true,
                valid: false,
                loading: false,
                lateRegistration: true,
                eventRegistration: {
                    name: null,
                    starter_type_id: null,
                    age_group_id: null,
                    starter_style_id: null,
                    event_registration_members: []
                },
                rules: {
                    name: [
                        (v) => !!v || 'Name fehlt'
                    ],
                    age_group: [
                        (v) => !!v || 'Altersklasse fehlt'
                    ],
                    price: [
                        (v) => !!v || 'Preis fehlt'
                    ]
                }
            }
        },
        computed: {
            filteredStarterTypes() {
                let starterTypes = _.filter(this.starterTypes.items, s => this.eventRegistration.event !== undefined && s.event_rule_id === this.eventRegistration.event.event_rule_id);

                starterTypes = _.map(starterTypes, s => {
                    s.label = this.$t(s.name);
                    return s;
                });

                return starterTypes;
            },
            filteredAgeGroups() {
                return _.filter(this.ageGroups.items, a => this.eventRegistration.event !== undefined && a.event_rule_id === this.eventRegistration.event.event_rule_id);
            },
            filteredStarterStyles() {
                return _.filter(this.starterStyles.items, s => this.eventRegistration.event !== undefined && s.event_rule_id === this.eventRegistration.event.event_rule_id);
            },
            ...mapState(['ageGroups', 'starterStyles', 'starterTypes'])
        },
        mounted() {
            if (this.id) {
                this.loadEventRegistration(this.id);
            }
        },
        methods: {
            loadEventRegistration(id) {
                this.loading = true;

                this.eventRegistration.id = parseInt(id);

                axios.get(`/api/v1/event_registrations/${id}`).then(response => {

                    if (!response.data.success) {
                        return;
                    }

                    this.$set(this, 'eventRegistration', response.data.data);

                    this.loading = false;
                }, errorResponse => {
                    console.log(errorResponse);
                    this.loading = false;
                });
            },
            submit () {
                if (!this.valid) {
                    console.log('not valid');
                    return;
                }

                this.loading = true;

                axios.put(`/api/v1/event_registrations/${this.eventRegistration.id}`, this.eventRegistration).then(response => {

                    if (!response.data.success) {
                        return;
                    }

                    this.loading = false;

                    this.$router.push(`/event-reports/${response.data.data.event_id}`);

                    this.$store.commit('snackBar', {
                        color: 'success',
                        text: this.$t('was_saved', [response.data.data.name])
                    });

                }, errorResponse => {
                    console.log(errorResponse);
                    this.loading = false;
                });
            },
            cancel () {
                this.$router.go(-1);
            },
            updateRegistration(registration) {
                this.$set(this, 'eventRegistration', registration);
                //this.loadEventRegistration(this.id);
            },
            deleteMember(member) {
                this.confirm({
                    headline: `${member.full_name} löschen`,
                    text: `${member.full_name} wirklich aus Starter entfernen?`,
                    callback: () => {
                        this.loading = true;
                        axios.delete(`/api/v1/event_registration_members/${member.id}`).then(response => {

                            if (!response.data.success) {
                                this.loading = false;
                                this.snackBar({
                                    color: 'error',
                                    text: response.data.message
                                });
                                return;
                            }

                            this.eventRegistration.event_registration_members = 
                                _.filter(this.eventRegistration.event_registration_members, m => m.id !== member.id);

                            this.eventRegistration.starter_type_id = response.data.data.starter_type_id;
                            
                            this.snackBar({
                                color: 'success',
                                text: `${member.full_name} wurde gelöscht`
                            });

                            this.loading = false;

                        }, errorResponse => {
                            console.log(errorResponse);
                            this.loading = false;
                        });
                    }
                });
            },
            cancelStarter() {
                this.confirm({
                    headline: `${this.eventRegistration.name} stornieren`,
                    text: `Die Meldung wird ohne Erstattung (Gutschrift) gelöscht. Sie wird dem Benutzer durchgestrichen angezeigt. ${this.eventRegistration.name} wirklich stornieren?`,
                    callback: () => {
                        this.loading = true;
                        axios.delete(`/api/v1/event_registrations/${this.eventRegistration.id}`).then(response => {

                            if (!response.data.success) {
                                this.loading = false;
                                this.snackBar({
                                    color: 'error',
                                    text: response.data.message
                                });
                                return;
                            }
                            
                            this.snackBar({
                                color: 'success',
                                text: `${this.eventRegistration.name} wurde storniert`
                            });

                            this.$router.go(-1);

                        }, errorResponse => {
                            console.log(errorResponse);
                            this.loading = false;
                        });
                    }
                });
            },
            ...mapMutations(['confirm', 'snackBar'])
        }
    }
</script>

<style scoped>
    .btn-save {
        float: right;
        margin-top: 2px;
    }

    .btn-cancel {
        margin-top: -10px;
    }

    h1 {
        display: inline-block;
        margin-bottom: 18px;
        margin-left: 10px;
    }
</style>
